export default function WhatIsSection() {
  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4 whitespace-nowrap">
              How It Works
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-5">
              What Is Sugargoo Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              Sugargoo Spreadsheet is a curated product database designed to help shoppers discover popular items faster. Instead of manually searching through thousands of products across marketplaces, you can explore organized spreadsheets containing fashion finds, sneakers, streetwear, electronics, accessories, and trending products — all verified and updated regularly.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              The spreadsheet transforms hours of product research into minutes of effortless browsing. Every entry is categorized, rated, and linked directly to the source, giving you a streamlined path from discovery to purchase.
            </p>

            <div className="overflow-hidden rounded-lg border border-background-200/70">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-background-200/50">
                    <th className="text-left px-4 py-3 font-semibold text-foreground-800 whitespace-nowrap">Method</th>
                    <th className="text-left px-4 py-3 font-semibold text-foreground-800 whitespace-nowrap">Searching Alone</th>
                    <th className="text-left px-4 py-3 font-semibold text-primary-700 whitespace-nowrap">Sugargoo Spreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ['Product Discovery', 'Slow', 'Fast'],
                    ['Organization', 'Poor', 'Categories'],
                    ['Beginner Friendly', 'Difficult', 'Easy'],
                    ['Research Time', 'Hours', 'Minutes'],
                    ['Product Ideas', 'Limited', 'Thousands'],
                  ].map(([method, alone, spreadsheet]) => (
                    <tr key={method} className="border-t border-background-200/50">
                      <td className="px-4 py-2.5 text-foreground-700 font-medium whitespace-nowrap">{method}</td>
                      <td className="px-4 py-2.5 text-foreground-500 whitespace-nowrap">{alone}</td>
                      <td className="px-4 py-2.5 text-primary-700 font-semibold whitespace-nowrap">{spreadsheet}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="lg:w-1/2 w-full">
            <div className="relative rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20organized%20modern%20product%20display%20with%20curated%20fashion%20items%20sneakers%20hoodies%20and%20accessories%20arranged%20on%20minimal%20warm%20cream%20shelves%2C%20soft%20natural%20daylight%20from%20window%2C%20editorial%20catalog%20photography%20style%2C%20warm%20earthy%20beige%20and%20cream%20palette%20with%20subtle%20terracotta%20touches%2C%20curated%20collection%20aesthetic%20with%20organized%20compartments%2C%20textured%20neutral%20backdrop%20with%20dried%20botanical%20elements&width=800&height=600&seq=whatis-v2-2026&orientation=landscape"
                alt="Sugargoo Spreadsheet curated product database"
                className="w-full h-auto rounded-xl"
                title="Sugargoo Spreadsheet - Curated Product Database"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}